// src/routes/RequireRole.tsx
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

interface RequireRoleProps {
  allowedRoles: string[];
  children: ReactNode;
}

const RequireRole = ({ allowedRoles, children }: RequireRoleProps) => {
  const { isLoggedIn, role, rehydrated, user } = useAppSelector((state) => state.auth);

  console.log('🔐 RequireRole Check:', {
    isLoggedIn,
    role,
    rehydrated,
    allowedRoles,
    hasUser: !!user
  });

  if (!rehydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-light dark:bg-dark">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <p className="text-slate-600 dark:text-slate-400">Checking permissions...</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    console.log('❌ Not logged in, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Get role from user object if role is not set
  const userRole = role || user?.role;
  
  console.log('👤 User role check:', { userRole, allowedRoles });

  if (!userRole || !allowedRoles.includes(userRole)) {
    console.log('❌ Role not allowed, redirecting to unauthorized');
    return <Navigate to="/unauthorized" replace />;
  }

  console.log('✅ Role check passed, allowing access');
  return <>{children}</>;
};

export default RequireRole;
